/* global Notification */
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/messaging'
import jwtDecode from 'jwt-decode'

// TODO - вырезать
console.debug('firebase.js ', 'process.env.NODE_ENV = ', process.env.NODE_ENV)

let firebaseConfig
if (process.env.NODE_ENV === 'development') {
  // TODO - вырезать
  console.debug('firebase.js ', 'Firebase запущен. Аккаунт - nitra-s')

  firebaseConfig = {
    apiKey: 'AIzaSyCRzcW84M8VOlsALWpuNQKYwgOKBAesADU',
    authDomain: 'nitra-s.firebaseapp.com',
    databaseURL: 'https://nitra-s.firebaseio.com',
    projectId: 'nitra-s',
    storageBucket: 'nitra-s.appspot.com',
    messagingSenderId: '626630714885',
    appId: '1:626630714885:web:ed41a260b0a77242'
  }
  // firebaseConfig = {
  //   apiKey: 'AIzaSyCC3WYh7oAg1KLbxqsxaNyh2aN1KgNUd9Y',
  //   authDomain: 'goodwinua.firebaseapp.com',
  //   databaseURL: 'https://goodwinua.firebaseio.com',
  //   projectId: 'goodwinua',
  //   storageBucket: 'goodwinua.appspot.com',
  //   messagingSenderId: '446859768387',
  //   appId: '1:446859768387:web:523ca9577cc9b5d5089af6'
  // }
} else {
  // TODO - вырезать
  console.debug('firebase.js ', 'Firebase запущен. Аккаунт - goodwinua')

  firebaseConfig = {
    apiKey: 'AIzaSyCC3WYh7oAg1KLbxqsxaNyh2aN1KgNUd9Y',
    authDomain: 'goodwinua.firebaseapp.com',
    databaseURL: 'https://goodwinua.firebaseio.com',
    projectId: 'goodwinua',
    storageBucket: 'goodwinua.appspot.com',
    messagingSenderId: '446859768387',
    appId: '1:446859768387:web:523ca9577cc9b5d5089af6'
  }
}

// TODO - вырезать
console.debug('firebase.js ', 'firebaseConfig = ', firebaseConfig)

// Инициализация firebase
firebase.initializeApp(firebaseConfig)

const messaging = firebase.messaging()

const subscribePush = async () => {
  // запрашиваем разрешение на получение уведомлений

  // Если юзер разрешил уведомления
  /**
   * denied - запрет на уведомления
   * default - юзер еще не получал запроса на уведмления
   */

  if (
    window.store.state.auth.pushToken !== '' &&
    Notification.permission === 'granted'
  ) {
    console.log('PUSH уведомления инициализированы')
    return false
  }
  // Запрашиваем разрешение на показ уведомлений
  await messaging.requestPermission()

  // создаем токен

  const token = await messaging.getToken()

  window.store.commit('auth/setPushToken', token)

  return token
}

let jwtToken = ''
let userData = ''
let authData = {}

/**
 * Обновление авторизации
 * @returns {String} jwt токен c ролями  и т.п.
 */
const checkAuth = async () => {
  const user = await authStateChanged()

  // Если юзер не залогинен
  if (!user) {
    if (window.route.meta.category === 'login') {
      return ''
    }
    jwtToken = ''
    window.store.commit('auth/setPushToken', '')

    window.location.href = '/sign-in'
    return ''
  }

  if (window.route.meta.category === 'login') {
    window.location.href = '/'

    return 'redirect'
  }

  const token = await user.getIdToken(true)

  if (!token) {
    console.debug('Не найден jwt токен | firebase.js')
  }

  console.log({
    label: 'JWT',
    body: { token, decode: jwtDecode(token) }
  })

  // Декодируем jwt
  authData = jwtDecode(token)

  if (!authData['https://hasura.io/jwt/claims']) {
    await signOut()
    window.location.href = '/sign-in'

    return ''
  }

  // Записываем ключ jwt
  jwtToken = token

  // Записываем данные о юзере которве вернул firebase
  userData = user

  return token
}

// Выход из приложения
const signOut = async () => {
  await firebase.auth().signOut()

  await checkAuth()
}

/**
 * Чекаємо закінчення firebase авторизації
 *
 * @return {Promise<Object>} користувач firebase
 */
async function authStateChanged() {
  return new Promise(function (resolve, reject) {
    try {
      firebase.auth().onAuthStateChanged(user => {
        // Авторизація закінчилась
        resolve(user)
      })
    } catch (err) {
      reject(err)
    }
  })
}

export { signOut, checkAuth, subscribePush, jwtToken, userData, authData }
